export default "__VITE_ASSET__CD52NhmU__"